import React from 'react'

export const UsuarioColaborador = () => {
  return (
    <div>UsuarioColaborador</div>
  )
}
